import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CompaniesComponent } from './companies.component';

import { AuthGuardService } from '../services/auth-guard.service';
import { CompaniesGuardService } from '../services/companies-guard.service';

const companiesRoutes: Routes = [
  { path: 'companies', component: CompaniesComponent, canActivate: [AuthGuardService, CompaniesGuardService] },
];

@NgModule({
  imports: [
    RouterModule.forChild(companiesRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [AuthGuardService, CompaniesGuardService],
})
export class CompaniesRoutingModule { }



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/companies/companies-routing.module.ts